export default __webpack_public_path__ + "static/media/our-values-image.78bb5680.jpg";